import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Button from '../../../buttons/Button';
import MobilePrinterContent from './MobilePrinterContent';
import { useMobilePrinter } from '../../../../hooks/useMobilePrinter';
import styles from './MobilePrinter.css';

const useStyles = makeStyles({
  mobilePrinterRoot: {
    '@media (min-width:500px)': {
      width: '100%',
    },
  },
});

const MobilePrinter = () => {
  const { t } = useTranslation();
  const translationRoot = 'MOBILE_PRINTER';

  const classes = useStyles();

  const {
    shouldDisableConnectButton,
    manualPrinterNumber,
    isPrinterConnected,
    connectedPrinterNumber,
    mobilePrinterList,
    mobilePrinterListError,
    mobilePrinterListLoading,
    selectedPrinterFromList,
    handlePrinterConnectionToggle,
    handleManualPrinterNumberChange,
    handlePrinterSelectionFromList,
  } = useMobilePrinter(true);

  return (
    <div className={styles.mainContent}>
      <h2>{t(`${translationRoot}.CONNECT_TO_MOBILE_PRINTER_TITLE`)}</h2>
      <MobilePrinterContent
        isPrinterConnected={isPrinterConnected}
        manualPrinterNumber={manualPrinterNumber}
        handleManualPrinterNumberChange={handleManualPrinterNumberChange}
        translationRoot={translationRoot}
        inputRootClass={classes.mobilePrinterRoot}
        mobilePrinterListError={mobilePrinterListError}
        mobilePrinterList={mobilePrinterList}
        mobilePrinterListLoading={mobilePrinterListLoading}
        handlePrinterSelectionFromList={handlePrinterSelectionFromList}
        selectedPrinterFromList={selectedPrinterFromList}
        connectedPrinterNumber={connectedPrinterNumber}
      />
      <div className={styles.paginationContainer}>
        <Button
          className={styles.footerButton}
          onClick={handlePrinterConnectionToggle}
          disabled={shouldDisableConnectButton}
        >
          {t(`${translationRoot}.${isPrinterConnected ? 'DISCONNECT' : 'CONNECT'}`)}
        </Button>
      </div>
    </div>
  );
};

export default MobilePrinter;
